import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-073ae5ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"background":"white"},
  class: "pt-8"
}
const _hoisted_2 = { class: "container pb-4 px-4 lg:px-4" }
const _hoisted_3 = { class: "mt-8 mb-4 flex align-center" }
const _hoisted_4 = { class: "flex-1 text-2xl md:text-3xl lg:mx-auto" }
const _hoisted_5 = { class: "flex flex-col items-end" }
const _hoisted_6 = { class: "mb-4 flex flex-row items-center" }
const _hoisted_7 = {
  key: 0,
  class: "createSurveyButtonHolder"
}
const _hoisted_8 = {
  key: 1,
  class: "ml-3"
}
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "container pb-4 px-4 lg:px-4" }
const _hoisted_11 = { class: "py-4 block md:flex flex-row-reverse text-xl items-center" }
const _hoisted_12 = { class: "flex-1 md:text-right" }
const _hoisted_13 = {
  key: 0,
  class: "mt-4 justify-self-start flex flex-col sm:flex-row flex-wrap items-start sm:items-center"
}
const _hoisted_14 = { class: "button-group flex" }
const _hoisted_15 = {
  key: 2,
  class: "flex flex-row items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserDialogButton = _resolveComponent("UserDialogButton")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_Searchbar = _resolveComponent("Searchbar")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_sort_by = _resolveComponent("sort-by")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_offline_hint = _resolveComponent("offline-hint")!
  const _component_socket_disconnected_hint = _resolveComponent("socket-disconnected-hint")!
  const _component_hzba_list = _resolveComponent("hzba-list")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, {
        title: $setup.t(`${$setup.organisationPrefix}hzba.bestandsaufnahmen`)
      }, {
        trailing: _withCtx(() => [
          _createVNode(_component_UserDialogButton)
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => ($setup.doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t(`${$setup.organisationPrefix}hzba.bestandsaufnahmen`)), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    ($setup.canCreateSurvey && $setup.featureFlags?.createSurvey)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (!$setup.isSelectModeEnabled)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                slot: "icon-only",
                                class: "h-14 w-14 cursor-pointer create-survey-button",
                                icon: $setup.addOutline,
                                onClick: $setup.openCreateSurveyModal
                              }, null, 8, ["icon", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.featureFlags?.survey?.exportxls || $setup.featureFlags?.survey?.exportgeojson)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_ExportButtons, {
                            "show-as-start-button": $setup.isSelectModeEnabled,
                            onExportGeojson: $setup.exportGeoJson
                          }, null, 8, ["show-as-start-button", "onExportGeojson"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    ($setup.displayCountLabel)
                      ? (_openBlock(), _createBlock(_component_ion_label, {
                          key: 0,
                          class: "text-lg text-right"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.displayCountLabel), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($setup.totalCount === null)
                      ? (_openBlock(), _createBlock(_component_ion_spinner, {
                          key: 1,
                          class: "ml-2 h-5 w-5",
                          color: "light"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode(_component_Searchbar, {
                "search-term": $setup.searchTerm,
                "onUpdate:searchTerm": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchTerm) = $event)),
                "sort-term": $setup.sortTerm,
                "onUpdate:sortTerm": _cache[2] || (_cache[2] = ($event: any) => (($setup.sortTerm) = $event))
              }, null, 8, ["search-term", "sort-term"]),
              _createVNode(_component_Filters, {
                "selected-filters": $setup.selectedFilters,
                "onUpdate:selectedFilters": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedFilters) = $event)),
                "filter-options": $setup.filterOptions,
                "onUpdate:dateFilter": _cache[4] || (_cache[4] = ($event: any) => ($setup.dateFilter = $event))
              }, null, 8, ["selected-filters", "filter-options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_sort_by, {
                  "sort-term": $setup.sortTerm,
                  "onUpdate:sortTerm": _cache[5] || (_cache[5] = ($event: any) => (($setup.sortTerm) = $event)),
                  "sort-terms": $setup.supportedSortTerms
                }, null, 8, ["sort-term", "sort-terms"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString($setup.t("hzba.zuletztAktualisiertAm")) + ": " + _toDisplayString($setup.lastFetch) + " ", 1),
                  _createVNode(_component_a_button, {
                    onClick: _cache[6] || (_cache[6] = () => $setup.doRefresh(_ctx.$event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Refresh ")
                    ]),
                    _: 1
                  })
                ]),
                ($setup.isSelectModeEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_ion_label, { class: "mb-2 sm:mb-0 pr-8" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.selectModeState === $setup.SelectModeState.ALL ? $setup.totalCount : $setup.countOfSelectedCards) + " selektiert ", 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ion_button, {
                          class: "action-button group-button first",
                          onClick: $setup.selectAllCards
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('hzba.export.all')) + " (" + _toDisplayString($setup.totalCount) + ") ", 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_ion_button, {
                          class: "action-button group-button middle",
                          onClick: $setup.deselectAllCards
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('hzba.export.none')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_ion_button, {
                          class: "action-button group-button last",
                          onClick: $setup.stopSelectMode
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('hzba.export.abortExport')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_offline_hint, {
              class: "mb-4",
              style: {"margin-top":"0"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t(`${$setup.organisationPrefix}hzba.noInternetConnectionInfo`)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_socket_disconnected_hint, { class: "mb-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t(`${$setup.organisationPrefix}hzba.noSocketConnectionInfo`)), 1)
              ]),
              _: 1
            }),
            ($setup.loaded)
              ? (_openBlock(), _createBlock(_component_hzba_list, {
                  key: 0,
                  hzbas: $setup.bas,
                  "enable-select": $setup.isSelectModeEnabled
                }, null, 8, ["hzbas", "enable-select"]))
              : (_openBlock(), _createBlock(_component_Skeleton, { key: 1 })),
            ($setup.showLoadMore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_AButton, {
                    type: "submit",
                    "btn-primary": true,
                    class: "px-16 py-6 mb-2 text-lg",
                    "data-cy": "button-login",
                    style: {"margin-top":"32px !important","margin-left":"0"},
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.loadMore()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t("buttons.loadMore")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}